


import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom/dist";
import Table from "../../../../core/pagination/datatable";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import { Select, Spin } from "antd";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  RotateCcw,
  Eye,
} from "feather-icons-react/build/IconComponents";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
// import Swal from "sweetalert2";

const AdvanceAdjustment = () => {
  const [dataLoading, setDataLoading] = useState(false);
  console.log(setDataLoading);
  const navigate = useNavigate();

  // Static JSON data as requested
const staticData = [
  {
    id: 1,
    employee: "Ramesh Kumar",
    empCode: "EMP101",
    grossSalary: 40000,
    advanceTaken: 10000,
    advanceAdjusted: 5000,
    pf: 1800,
    esi: 600,
    netPay: 31600,
    payPeriod: "Apr-2024",
  },
  {
    id: 2,
    employee: "Suresh Patel",
    empCode: "EMP102",
    grossSalary: 30000,
    advanceTaken: 5000,
    advanceAdjusted: 3000,
    pf: 1800,
    esi: 450,
    netPay: 24750,
    payPeriod: "Apr-2024",
  },
  {
    id: 3,
    employee: "Anita Sharma",
    empCode: "EMP103",
    grossSalary: 25000,
    advanceTaken: 0,
    advanceAdjusted: 0,
    pf: 1800,
    esi: 375,
    netPay: 22825,
    payPeriod: "Apr-2024",
  },
];

  const [data] = useState(staticData);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

 const columns = [
  {
    title: "S.No",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Employee",
    dataIndex: "employee",
  },
  {
    title: "Emp Code",
    dataIndex: "empCode",
  },
  {
    title: "Gross Salary",
    dataIndex: "grossSalary",
    render: (val) => `₹${val.toLocaleString("en-IN")}`,
  },
  {
    title: "Adv Taken",
    dataIndex: "advanceTaken",
    render: (val) => `₹${val.toLocaleString("en-IN")}`,
  },
  {
    title: "Adv Adjustment",
    dataIndex: "advanceAdjusted",
    render: (val) => `₹${val.toLocaleString("en-IN")}`,
  },
  {
    title: "PF",
    dataIndex: "pf",
    render: (val) => `₹${val.toLocaleString("en-IN")}`,
  },
  {
    title: "ESI",
    dataIndex: "esi",
    render: (val) => `₹${val.toLocaleString("en-IN")}`,
  },
  {
    title: "Net Pay (₹)",
    dataIndex: "netPay",
    render: (val) => (
      <span className="fw-semibold text-success">
        ₹{val.toLocaleString("en-IN")}
      </span>
    ),
  },
  {
    title: "Pay Period",
    dataIndex: "payPeriod",
  },
  {
    title: "Action",
    render: (_, record) => (
      <button
        className="btn btn-link p-0 text-info"
        title="View"
        onClick={() => navigate("#", { state: record })}
      >
        <Eye size={18} />
      </button>
    ),
  },
];

  const handleReload = () => {
    window.location.reload();
  };

  const handleDownloadExcel = () => {
    if (data.length === 0) return;

    const wb = XLSX.utils.book_new();
    const wsData = data.map((item, index) => ({
      "S.No": index + 1,
      Employee: item.employee,
      "Emp Code": item.empCode,
      "Monthly Salary": item.monthlySalary,
      "Yearly CTC": item.yearlyCTC,
      Group: item.group,
      "Start Date": formatDate(item.startDate),
      "End Date": formatDate(item.endDate),
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Annual CTC");
    XLSX.writeFile(wb, "Employee_Annual_CTC.xlsx");
  };

  const generatePDF = () => {
    if (data.length === 0) return;

    const doc = new jsPDF();
    doc.text("Employee Annual CTC Report", 14, 10);

    const tableColumn = [
      "S.No",
      "Employee",
      "Emp Code",
      "Monthly Salary",
      "Yearly CTC",
      "Group",
      "Start Date",
      "End Date",
    ];
    const tableRows = data.map((item, index) => [
      index + 1,
      item.employee,
      item.empCode,
      `$${item.monthlySalary.toLocaleString()}`,
      `$${item.yearlyCTC.toLocaleString()}`,
      `$${item.group.toLocaleString()}`,
      formatDate(item.startDate),
      formatDate(item.endDate),
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows, startY: 20 });
    doc.save("Employee_Annual_CTC.pdf");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      PDF
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  return (
    <div>
      <div className="page-wrapper">
         <div className="content">
          <div className="page-header m-2">
            <div className="add-item d-flex">
             <div className="page-title">
               <nav aria-label="breadcrumb">
                 <ol className="breadcrumb">
                   <li className="breadcrumb-item">
                     <Link to="/rollcall/dashboard">
                       <i className="fas fa-home fa-lg" />
                     </Link>
                   </li>
                   <h4 className="breadcrumb-item " aria-current="page">
                     Advance Adjustment
                   </h4>
                 </ol>
               </nav>
               <h6>Manage your Advance Adjustment here</h6>
             </div>
           </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link onClick={generatePDF}>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="PDF"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link onClick={handleDownloadExcel}>
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="Excel"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link>
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
             <div className="search-set">
             <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm"
                    // value={searchInput}
                    // onChange={(e) => setSearchInput(e.target.value)}
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div> 
         </div>
              <div className="d-flex right-content align-items-end ">
                <div className="">
                 {/* <label className="form-label">Employee</label> */}
                  <div
                    className="form-control p-0 border-0"
                    style={{ width: 200 }}
                  >
                    <Select
                      showSearch
                      placeholder="Choose Pay Period"
                    //   value={slectedEmp || undefined}
                    //   onChange={handleEmpChange}
                      filterOption={(input, option) =>
                        option?.label
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    //   options={empOptions}
                      style={{ width: 170, height: 37 }}
                    />
                  </div>
                </div>
                <div className="">
                  {/* <label className="form-label">Department</label> */}
                  <div
                    className="form-control p-0 border-0"
                    style={{ width: 200 }}
                  >
                    <Select
                      showSearch
                      placeholder="Choose Branch"
                    //   value={slectedDept || undefined}
                    //   onChange={handleDeptChange}
                      filterOption={(input, option) =>
                        option?.label
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    //   options={departmentOptions}
                      style={{ width: 170, height: 37 }}
                    />
                  </div>
                </div>
                  <div className="">
                  {/* <label className="form-label">Department</label> */}
                  <div
                    className="form-control p-0 border-0"
                    style={{ width: 200 }}
                  >
                    <Select
                      showSearch
                      placeholder="Choose Department"
                    //   value={slectedDept || undefined}
                    //   onChange={handleDeptChange}
                      filterOption={(input, option) =>
                        option?.label
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    //   options={departmentOptions}
                      style={{ width: 170, height: 37 }}
                    />
                  </div>
                </div>
                  <div className="">
                  {/* <label className="form-label">Department</label> */}
                  <div
                    className="form-control p-0 border-0"
                    style={{ width: 200 }}
                  >
                    <Select
                      showSearch
                      placeholder="Choose Employee"
                    //   value={slectedDept || undefined}
                    //   onChange={handleDeptChange}
                      filterOption={(input, option) =>
                        option?.label
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    //   options={departmentOptions}
                      style={{ width: 170, height: 37 }}
                    />
                  </div>
                </div>

                <div className=" ">
                  <button
                    className="btn btn-primary"
                    // onClick={handleButtonClick}
                  >
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                  </button>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive brand-table">
                {dataLoading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <Table columns={columns} dataSource={data} rowKey="id" />
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
    </div>
  );
};

export default AdvanceAdjustment;